import { createDomain, fork, Scope } from 'effector';
import { createGate } from 'effector-react';
import { FilterConfig, Filters } from '../../types';

export const FilterToolbarDomain = createDomain();
export const FilterToolbarGate = createGate();

export const $config = FilterToolbarDomain.createStore<FilterConfig | null>(null);
export const $filters = FilterToolbarDomain.createStore<Filters>({});

export const setFilters = FilterToolbarDomain.createEvent<Filters>();
export const setConfig = FilterToolbarDomain.createEvent<FilterConfig>();

export const scopes: { [key: string]: Scope } = {};

export const createFilterToolbarScope = (name: string) => {
  if (scopes[name]) return scopes[name];
  scopes[name] = fork(FilterToolbarDomain);

  return scopes[name];
};
